import React, {useEffect, useRef, useState} from 'react';
import {Link, useNavigate} from "react-router";
import {useAuth} from "../context/authContext.tsx";
import {Employee, loginLService, loginOTPService, loginService} from "../services/employee.ts";
import Label from "../components/Label.tsx";
import Button from "../components/button/button.tsx";
import AuthLayout from "../components/AuthPageLayout.tsx";
import {AxiosError} from "axios";
import {useAuthOTP} from "../context/auth/authOtpContext.tsx";
import Cookies from 'js-cookie';
import { getAuthenticatedHomeRoute } from "../utils/auth.ts";
import { digitalOceanImageUrl } from "../utils/digitalOcean.ts";

const OTPLogin = () => {
    const [errors, setErrors] = useState<string>("");
    const [regeneration, setRegeneration] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingGen, setLoadingGen] = useState<boolean>(false);

    const {email} = useAuthOTP();

    const [input1, setInput1] = useState<string>("");
    const [input2, setInput2] = useState<string>("");
    const [input3, setInput3] = useState<string>("");
    const [input4, setInput4] = useState<string>("");
    const [input5, setInput5] = useState<string>("");
    const otpInputRefs = useRef<Array<HTMLInputElement | null>>([]);
    const isPastingRef = useRef(false);


    const {setEmp, employeeI, authReady} = useAuth()
    const navigate = useNavigate();

    useEffect(() => {
        if (!authReady || !employeeI) {
            return;
        }
        navigate(getAuthenticatedHomeRoute(employeeI), { replace: true });
    }, [authReady, employeeI, navigate]);

    const setOtpAtIndex = (index: number, value: string) => {
        if (index === 0) setInput1(value);
        if (index === 1) setInput2(value);
        if (index === 2) setInput3(value);
        if (index === 3) setInput4(value);
        if (index === 4) setInput5(value);
    };

    const handleOtpPaste = (startIndex: number) => (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
        isPastingRef.current = true;

        const pasted = e.clipboardData
            .getData("text")
            .replace(/\s+/g, "")
            .split("")
            .filter((char) => /[A-Za-z0-9]/.test(char));

        if (pasted.length === 0) {
            isPastingRef.current = false;
            return;
        }

        const maxFill = Math.min(5 - startIndex, pasted.length);
        for (let offset = 0; offset < maxFill; offset++) {
            setOtpAtIndex(startIndex + offset, pasted[offset]);
        }

        const nextIndex = startIndex + maxFill;
        if (nextIndex <= 4) {
            otpInputRefs.current[nextIndex]?.focus();
        } else {
            otpInputRefs.current[4]?.focus();
        }

        setTimeout(() => {
            isPastingRef.current = false;
        }, 0);
    };

    const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        if (loadingGen || loading) {
            return;
        }
        setErrors("");

        if (email.length <=0 || !email.includes("@kiiramotors.com")) {
            setErrors("Please enter a valid email ending with @kiiramotors.com");
            setLoading(false);
            navigate("/login", { replace: true });
            return;
        }

        if (input1.length <= 0) {
            setErrors("Please enter a valid OTP");
            setLoading(false);
            return;
        }
        if (input2.length <= 0) {
            setErrors("Please enter a valid OTP");
            setLoading(false);
            return;
        }
        if (input3.length <= 0) {
            setErrors("Please enter a valid OTP");
            setLoading(false);
            return;
        }
        if (input4.length <= 0) {
            setErrors("Please enter a valid OTP");
            setLoading(false);
            return;
        }
        if (input5.length <= 0) {
            setErrors("Please enter a valid OTP");
            setLoading(false);
            return;
        }
        try {
            const result = await loginOTPService({
                email: email,
                otp: input1+input2+input3+input4+input5
            })
            console.log(Cookies)
            const data: Employee = result.data;
        
            setEmp(data);
            navigate(getAuthenticatedHomeRoute(data), { replace: true });

            // console.log(result.data)
        } catch (error) {
            if (error instanceof AxiosError) {
                if (error.response) {
                    if (error.response.status === 500) {
                        setErrors("Something on our end went wrong");
                        setLoading(false);
                        return;
                    }
                    if (error.response.data) {
                        setErrors(error.response.data.error);
                        setLoading(false);
                        return;
                    }
                    setErrors("Something went wrong!");
                    setLoading(false);
                    return;
                }
                setErrors("Something went wrong!");
                setLoading(false);
                return;
            }
            setErrors("Something went wrong!");

        }

        setLoading(false);

    }

    const submitReGeneration = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if (loadingGen || loading) {
            return;
        }
        setLoadingGen(true);
        setErrors("");
        loginLService({email: email}).then((response) => {
            if (response) {
                setRegeneration("OTP sent successfully. Please check your email.");
                setLoadingGen(false);
            }
        }).catch(e => {
            if (e instanceof AxiosError) {
                if (e.response) {
                    if (e.response.status === 500) {
                        setErrors("Something on our end went wrong");
                        setLoadingGen(false);
                        return;
                    }
                    if (e.response.data) {
                        setErrors(e.response.data.error);
                        setLoadingGen(false);
                        return;
                    }
                    setErrors("Something went wrong!");
                    setLoadingGen(false);
                    return;
                }
                setErrors("Something went wrong!");
                setLoadingGen(false);
                return;
            }
            setErrors("Something went wrong!");
        })
    }


    return (
        // <AuthLayout>
            <div className="flex min-h-screen w-full bg-cover bg-center relative" style={{ backgroundImage: `url('${digitalOceanImageUrl("assets/images/_99A0320.JPG")}')` }}>
                <div className='absolute inset-0 bg-blue-900/40'></div>
                 <div className="hidden md:flex md:w-1/2 items-center justify-center relative backdrop-blur-md bg-black/10">  
                    <div className="relative z-10 flex flex-col items-center">
                        <img
                            src={digitalOceanImageUrl("assets/images/logo.png")}
                            alt="KMC Logo"
                            className="w-60 h-50 mb-4"
                        />
                        <p className="text-white font-bold text-3xl">
                            Production Processes Portal
                        </p>
                    </div>
                
                 </div>
                <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto ">
                    <div className='w-full rounded-xl shadow-md p-8 backdrop-blur-md bg-black/10 p-8 rounded-xl shadow-lg'>
                        <div className="mb-5 sm:mb-8  ">
                            {
                                errors.length > 0 && (
                                    <small className={`px-2 py-1.5 ring-1 ring-red-500 bg-red-300/70 rounded-md text-red-500`}>{errors}</small>
                                )
                            }
                            {
                                regeneration.length > 0 && (
                                    <small className={`px-2 py-1.5 ring-1 ring-green-500 bg-emerald-300/70 rounded-md text-green-500`}>{regeneration}</small>
                                )
                            }
                            <h1 className="mb-2 text-4xl max-lg:text-center max-lg:text-2xl font-semibold text-white text-title-smcsm:text-title-md">
                                One Time Password
                            </h1>
                            <div className="lg:hidden flex flex-col items-center justify-center w-full mb-2">
                                <Link to="/" className="block">
                                    <img
                                        width={231}
                                        height={48}
                                        src={digitalOceanImageUrl("assets/images/logo.png")}
                                        alt="Logo"
                                    />
                                </Link>
                                <p className="text-center text-white">
                                    Kiira Motors Corporation Production Process Portal
                                </p>
                            </div>
                            <p className="text-sm max-lg:text-center  text-gray-100">
                                Enter the <strong>OTP</strong> that was shared on your email to sign in!
                            </p>
                        </div>
                        <div>
                            <form onSubmit={submitHandler}>
                                <div className="space-y-6">
                                    <div>
                                        <Label>
                                           <span className='text-white'> OTP</span> <span className="text-blue-500">*</span>{" "}
                                        </Label>
                                        <div className={`w-full h-fit p-1 flex flex-row gap-2 items-center`}>
                                            <input
                                                   ref={(el) => { otpInputRefs.current[0] = el; }}
                                                   value={input1}
                                                   onChange={(e) => {
                                                       if (isPastingRef.current) return;
                                                       const value = e.target.value;
                                                       setInput1(value);
                                                       if (value.length === 1) {
                                                           otpInputRefs.current[1]?.focus();
                                                       }
                                                   }}
                                                   onPaste={handleOtpPaste(0)}
                                                   maxLength={1}
                                                   required={true} name={"input1"}
                                                   className={`w-14 h-16 rounded-md text-center ring-2 ring-transparent bg-blue-100 outline-0 focus:outline-0 focus:ring-blue-500 focus:bg-blue-50 text-xl text-gray-900 font-semibold invalid:ring-pink-600`}/>
                                            <p className={`text-lg font-bold text-white`}>-</p>
                                            <input
                                                   ref={(el) => { otpInputRefs.current[1] = el; }}
                                                   value={input2}
                                                   onChange={(e) => {
                                                       if (isPastingRef.current) return;
                                                       const value = e.target.value;
                                                       setInput2(value);
                                                       if (value.length === 1) {
                                                           otpInputRefs.current[2]?.focus();
                                                       }
                                                   }}
                                                   onPaste={handleOtpPaste(1)}
                                                   maxLength={1}
                                                   required={true} name={"input2"}
                                                   className={`w-14 h-16 rounded-md text-center ring-2 ring-transparent bg-blue-100 outline-0 focus:outline-0 focus:ring-blue-500 focus:bg-blue-50 text-xl text-gray-900 font-semibold invalid:ring-pink-600`}/>
                                            <p className={`text-lg font-bold text-white`}>-</p>
                                            <input
                                                   ref={(el) => { otpInputRefs.current[2] = el; }}
                                                   value={input3}
                                                   onChange={(e) => {
                                                       if (isPastingRef.current) return;
                                                       const value = e.target.value;
                                                       setInput3(value);
                                                       if (value.length === 1) {
                                                           otpInputRefs.current[3]?.focus();
                                                       }
                                                   }}
                                                   onPaste={handleOtpPaste(2)}
                                                   maxLength={1}
                                                   required={true} name={"input3"}
                                                   className={`w-14 h-16 rounded-md text-center ring-2 ring-transparent bg-blue-100 outline-0 focus:outline-0 focus:ring-blue-500 focus:bg-blue-50 text-xl text-gray-900 font-semibold invalid:ring-pink-600`}/>
                                            <p className={`text-lg font-bold text-white `}>-</p>
                                            <input
                                                   ref={(el) => { otpInputRefs.current[3] = el; }}
                                                   value={input4}
                                                   onChange={(e) => {
                                                       if (isPastingRef.current) return;
                                                       const value = e.target.value;
                                                       setInput4(value);
                                                       if (value.length === 1) {
                                                           otpInputRefs.current[4]?.focus();
                                                       }
                                                   }}
                                                   onPaste={handleOtpPaste(3)}
                                                   maxLength={1}
                                                   required={true} name={"input4"}
                                                   className={`w-14 h-16 rounded-md text-center ring-2 ring-transparent bg-blue-100 outline-0 focus:outline-0 focus:ring-blue-500 focus:bg-blue-50 text-xl text-gray-900 font-semibold invalid:ring-pink-600`}/>
                                            <p className={`text-lg font-bold text-white`}>-</p>
                                            <input
                                                   ref={(el) => { otpInputRefs.current[4] = el; }}
                                                   value={input5}
                                                   onChange={(e) => {
                                                       if (isPastingRef.current) return;
                                                       setInput5(e.target.value);
                                                   }}
                                                   onPaste={handleOtpPaste(4)}
                                                   maxLength={1}
                                                   required={true} name={"input5"}
                                                   className={`w-14 h-16 rounded-md text-center ring-2 ring-transparent bg-blue-100 outline-0 focus:outline-0 focus:ring-blue-500 focus:bg-blue-50 text-xl text-gray-900 font-semibold invalid:ring-pink-600`}/>
                                        </div>
                                    </div>

                                    <div>
                                        <Button disabled={loading || loadingGen} className="w-full" size="sm">
                                            {loading? "Signing in..." : "Sign In"}
                                        </Button>
                                    </div>
                                    <div>
                                        <button onClick={submitReGeneration} disabled={loading || loadingGen} className={`w-full h-fit inline-flex items-center py-3 justify-center gap-2 rounded-lg transition lg:text-lg font-bold text-gray-600 disabled:bg-gray-300 disabled:text-gray-500 ${loading || loadingGen ? "cursor-not-allowed opacity-50" : ""} hover:text-gray-500 bg-transparent hover:bg-gray-200`}>
                                            {loadingGen? "Generating..." : "Re-Generate"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                 {/* Right side - Dark background with logo */}
            
            </div>
        // </AuthLayout>
    );
};


export default OTPLogin;
